import { Box, styled } from '@mui/material';
import { PoolTypography } from '@synergy/components-next';
import { ReactElement } from 'react';

import backgroundImage from './login-picture.jpg';
import polygon from './login-polygon.svg';

const LoginImage = styled(Box)(({ theme }) => ({
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    color: theme.palette.common.white,
    width: '50%',
    display: 'flex',
    justifyContent: 'center',
    minWidth: '40%',
    alignItems: 'center',
    [theme.breakpoints.up('sm')]: {
        height: '100%',
        backgroundSize: 'contain, cover',
        backgroundImage: `url(${polygon}), url(${backgroundImage})`,
        backgroundPosition: 'bottom right, center center ',
    },
}));

export const LoginBanner = (): ReactElement => {
    return (
        <LoginImage>
            <PoolTypography sx={{ fontSize: '64px', fontWeight: 'bold' }}>POOLALPIN</PoolTypography>

            <PoolTypography />
        </LoginImage>
    );
};
